import React from "react";
import "../styles/footer.css";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaLinkedin, FaInstagram } from 'react-icons/fa';

/**
 * Footer
 *
 * Figma-aligned:
 * - Padding: 50px all sides (44px top/bottom in Figma; we match 44 via CSS)
 * - White background
 * - Row: logo | nav links (7) | social icons (3)
 * - Divider line, then centered copyright
 *
 * A11y:
 * - <footer role="contentinfo">
 * - <nav aria-label="Footer"> on links
 * - Social icons are <a> with aria-labels
 */
const Footer = ({
  logoSrc = "/media/TASFooter.png",
  links = [
    { label: "Our School", href: "/about" },
    { label: "Enrolments", href: "/enrolments" },
    { label: "Curriculum", href: "/curriculum" },
    { label: "Team", href: "/team" },
    { label: "Contact", href: "/contact" },
  ],
  socials = [
    { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61576600509884", type: "facebook" },
    { label: "Instagram", href: "https://www.instagram.com/theavenueschool/", type: "instagram" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/105613790/", type: "linkedin" },
  ],
  copyright = "Copyright © 2025 The Avenue School | All Rights Reserved",
}) => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-top">
        {/* Logo */}
        <div className="footer-logo">
          <img src={logoSrc} alt="The Avenue School logo" />
        </div>

        {/* Nav */}
        <nav className="footer-nav" aria-label="Footer">
          <ul className="footer-links" role="list">
            {links.map((l) => (
              <li key={l.label} className="footer-link-item">
                <a href={l.href} className="footer-link">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Socials */}
        <div className="footer-social">
          {socials.map((s, i) => (
            <a
              key={`${s.type}-${i}`}
              href={s.href}
              aria-label={s.label}
              className="social-btn"
            >
              <span className="social-swatch" aria-hidden="true">
                {s.type === "facebook" && (
                  <FaFacebookF className="fs-5" style={{ color: "#243a24" }}/>
                )}
                {s.type === "instagram" && (
                  <FaInstagram className="fs-5" style={{ color: "#243a24" }} />
                )}
                {s.type === "linkedin" && (
                  <FaLinkedin className="fs-5" style={{ color: "#243a24" }} />
                )}
              </span>
            </a>
          ))}
        </div>
      </div>

      {/* Divider + copyright */}
      <div className="footer-bottom">
        <hr className="footer-divider" />
        <p className="footer-copy">{copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;

